import { dataHandle } from '../../../services/data-handle.js';
import { Toast } from 'mint-ui';
import bus from '../../eventBus';
const VIDEO = '.mp4,.mov';
export default {
    props: {
        artificialLink: String,
        queuing: [String, Number]
    },
    data() {
        return {
            menuList: [],
            businessId: '',
            csQueuing: this.queuing,
            sheetVisible: false
        }
    },
    watch: {
        'queuing'(value) {
            this.csQueuing = value;
        }
    },
    mounted() {
        this.businessId = sessionStorage.getItem('business');
        this.accessKey = sessionStorage.getItem('accessKey');
        if (sessionStorage.getItem('menuList')) {
            this.menuList = JSON.parse(sessionStorage.getItem('menuList'));
        }
    },
    methods: {
        /**
         * 是否显示菜单
         * */
        isShowMenu(item){
            if (!item.isShow) {
                return false;
            }
            if (item.code == 'artificial') {
                if (this.csQueuing == 0) {
                    return true;
                }
                return false;
            }
            if (item.code == 'evaluate') {
                if (this.csQueuing == 1) {
                    return true;
                }
                return false;
            }
            if (item.code == 'business') {
                if (this.csQueuing == 0) {
                    return true;
                }
                return false;
            }
            return true;
        },
        /**
         * 菜单点击
         * */
        clickMenu(item){
            if (item.code == 'tel' || item.code == 'picture') {
                return;
            }
            if (item.code == 'artificial') {
                this.toCustomer();
            }else if(item.code == 'evaluate'){
                this.evaluate();
            }else if(item.code == 'business'){
                this.changeBussiness();
            }
        },
        /**
         * 切换业务
         *
         */
        changeBussiness() {
            this.$router.push({
                name: 'business'
            })
        },
        /**
         * 选择图片上传
         * formData.append('type', 1);    1=>图片  2=>视频   3=>语音
         * formData.append('channel', 1);    1=>H5
         * @param { String } type  => 上传图片方式  picture=>相册  camera=>拍照
         * @returns
         */
        async uploadImg(type) {
            let file = this.$refs[type][0].files[0];
            if(file.size>1024*1024*20) {
                Toast('您上传的图片/视频超过20M，请重新上传');
                return;
            }
            let fileType = '', fileTypeVal=1;
            let isImg = this.checkImgType(file.name);
            if (file.type.indexOf('image/') == 0 || isImg) {
                fileType = 'image';
                fileTypeVal = 1;
            }else if (file.type.indexOf('video/') == 0) {
                fileType = 'video';
                fileTypeVal = 2;
            }else{
                fileType = 'audio';
                fileTypeVal = 3;
            }
            if (fileType == 'video') {
                //返回String对象中子字符串最后出现的位置.
                const seat=file.name.lastIndexOf(".");
                //返回位于String对象中指定位置的子字符串并转换为小写.
                const extension=file.name.substring(seat).toLowerCase();
                if(VIDEO.indexOf(extension) == -1) {
                    Toast('视频格式只支持.mp4或者.mov');
                    return;
                }
            }
            let formData = new FormData();
            formData.append('file', file);
            formData.append('accessKey', this.accessKey);
            formData.append('type', fileTypeVal);
            formData.append('channel', 1);
            let res = await this.$http.postFile(`/upload`, formData);
            if(!res) return
            if(this.$refs[type] && this.$refs[type].value) this.$refs[type].value = '';

            bus.$emit('send', {
                type: fileType,
                content: res.data.fileId
            });
            this.inputBlur();
            //this.$parent.pushList(sendData);video
        },
        /**
         * 通过fileName判断是否为img(文件后缀)
         * */
        checkImgType(fileName){
            var suffixIndex=fileName.lastIndexOf(".");
            var suffix=fileName.substring(suffixIndex+1).toUpperCase();  
            if(suffix!="BMP"&&suffix!="JPG"&&suffix!="JPEG"&&suffix!="PNG"&&suffix!="GIF"){
                return false
            }
            return true;
        },
        /**
         * 解决键盘收起时页面没有回弹，出现空白
         */
        inputBlur() {
            // console.log('===blur===');
            this.$parent.getConversationH();
            // ios12及ios13键盘收起后会有半屏白屏，ios12修改body的scrollTop，ios13修改html的scrollTop
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        /**
         * 服务评价
         */
        evaluate() {
            this.$parent.toggleEvaluate();
        },
        toFeedback(){
            this.$parent.toFeedback();
        },
        /**
         * 转人工客服
         * */
        toCustomer(){
            this.$parent.transferCustomer();
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/webot/tool/_tool.js